module.exports = __webpack_public_path__ + "static/media/cv.4faddf1f.pdf";